import { mapGetters } from "vuex";

import { CreditsService, ErrorLogService, GridUtil } from "@/services";

import { formatDateTime, stringHelper } from "@/components/mixins";

import { CurrencyText, LoadingSpinner } from "@/components";
import DnTable from "@/components/Elements/DnTable/DnTable.vue";

export default {
    components: {
        CurrencyText,
        LoadingSpinner,
        DnTable,
    },
    mixins: [stringHelper, formatDateTime],
    props: {
        documentNumber: {
            type: String,
            default: "",
        },
        partNumber: {
            type: String,
            default: "",
        },
        dealerCodes: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        CreditResultsColumns: [
            { key: "InvoiceDate", localizationKey: "date", formatter: "formatDateTime" },
            { key: "InvoiceNumber", localizationKey: "creditInvoiceNumber" },
            { key: "ReferenceNumber", localizationKey: "referenceNumber" },
            { key: "PurchaseOrderNumber", localizationKey: "purchaseOrderNumber" },
            { key: "InvoiceSource", localizationKey: "source" },
            { key: "SubTotalFreight", localizationKey: "freight" },
            { key: "InvoiceTotalAmount", localizationKey: "total" },
        ],
        isCreditsLoading: true,
        credits: [],
    }),
    computed: {
        ...mapGetters(["getContentItem", "activeAccountId", "user", "hasPermission"]),
        SearchKeyword() {
            return this.documentNumber ? this.documentNumber : this.partNumber;
        },
    },
    mounted() {
        this.searchCredits();
        this.CreditResultsColumns = GridUtil.localizeColumnLabels(this.CreditResultsColumns, this.getContentItem);
    },
    methods: {
        async searchCredits() {

                var dealerCodesToSearch = JSON.parse(JSON.stringify( this.dealerCodes ));

                // clear out any existing credits because we will be concatenating results if there are more than 100 dealers
                this.credits = [];
                
                while(dealerCodesToSearch.length) {
                    var dealersToSearchUpTo100 = dealerCodesToSearch.splice(0,100);
                    try {
                        this.isCreditsLoading = true;
                    const req = {
                        accountId: this.activeAccountId,
                        userId: this.user.UserId,
                        partNumber: this.partNumber,
                        documentNumber: this.documentNumber,
                        dealerCodes: dealersToSearchUpTo100,
                    };
    
                    const response = await CreditsService.searchCreditMemosByDocumentOrPart(req);
    
                    this.credits = this.credits.concat(response.data);
                    } catch (err) {
                        ErrorLogService.LogException(err);
                        return [];
                    } finally {
                        this.isCreditsLoading = false;
                    }                    
                }
        },
    },
};
